import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import styled from 'styled-components';
import { Tooltip } from 'next/components/ui';
import { BeaconLink } from 'components/Common/HelpScout';

/*
 * re-implementation of this CSS is necessary because
 * simply styling the `CTab` element makes it difficult
 * to inhibit the 'click' action
 * See PR for discussion: https://github.com/appcues/studio/pull/2791#discussion_r704764028
 */

const Tab = styled(NavLink)`
  display: flex;
  flex-direction: column;
  position: relative;

  line-height: 1.625rem;

  padding: 19px 16px 18px;
  color: var(--tab-text);
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;

  transition: color 0.2s ease, background-color 0.2s ease;

  margin: 0;

  &:hover {
    color: var(--tab-hover);
  }

  &:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;

    z-index: 1;

    border: 1px solid var(--tab-active);
    border-radius: 4px;

    opacity: 0;
    transition: opacity 0.2s ease;
  }

  &.active {
    color: var(--tab-active);

    &::after {
      opacity: 1;
    }
  }
`;

const DisabledTab = styled(Tab)`
  opacity: 0.5;

  &:hover {
    color: var(--tab-disabled-hover);
  }
`;

const handleClick = e => e.preventDefault();

export const ApiKeysTab = ({ hasAPIKeys }) => {
  return hasAPIKeys ? (
    <Tab to="/settings/keys" id="keys">
      API Keys
    </Tab>
  ) : (
    <Tooltip
      disabled={false}
      label={
        <>
          <BeaconLink
            subject="Interested in the Public API"
            message="I'd like to upgrade my plan to access the Public API."
            light
          >
            Upgrade
          </BeaconLink>{' '}
          to get access to the Public API to manage data & automate tasks.{' '}
        </>
      }
      persist
      size="m"
    >
      <DisabledTab
        to="/settings/keys"
        id="keys-disabled"
        aria-disabled="true"
        onClick={handleClick}
      >
        API Keys
      </DisabledTab>
    </Tooltip>
  );
};

ApiKeysTab.propTypes = {
  hasAPIKeys: PropTypes.bool,
};

export default ApiKeysTab;
